import __request__ from "routing/request";
export function regexTester(regex, string, requestOptions) {
  return __request__("GET", "/tools/regex_tester", null, { "regex": regex, "string": string }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testRegex(JSONbody, requestOptions) {
  return __request__("POST", "/tools/regex_tester", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateRegex(regex, requestOptions) {
  return __request__("GET", "/tools/regex_tester/validate", null, { "regex": regex }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
